import { render, staticRenderFns } from "./CameraScanner.vue?vue&type=template&id=1d7c161e&"
import script from "./CameraScanner.vue?vue&type=script&lang=js&"
export * from "./CameraScanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports